
import Button from 'components/button';
import styled from 'styled-components';
import { Type } from 'theme/types';

export const ButtonVariant = styled(Button)`
  ${({ theme }: Type) => theme.agegate.buttonVariant}
`